module.exports = __webpack_public_path__ + "img/kv-sp.1370e33.jpg";